import { FormattedMessage } from 'react-intl';
import { config } from '../../../config';

export const AlreadyRegistered = () => {
    return (
        <div>
            <div className={'line-height-small'}>
                <FormattedMessage id={'intl-msg:registration.companyData.alreadyRegistered'} />
            </div>
            <a href={config.homeRoute}>
                <FormattedMessage id={'intl-msg:registration.loginNow'} />
            </a>
        </div>
    );
};
